/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MetaDataFromJSON, MetaDataToJSON, } from './MetaData';
import { PageRequestFromJSON, PageRequestToJSON, } from './PageRequest';
import { UserListEntryFromJSON, UserListEntryToJSON, } from './UserListEntry';
/**
 * Check if a given object implements the PagedResponseOfUserListEntry interface.
 */
export function instanceOfPagedResponseOfUserListEntry(value) {
    var isInstance = true;
    return isInstance;
}
export function PagedResponseOfUserListEntryFromJSON(json) {
    return PagedResponseOfUserListEntryFromJSONTyped(json, false);
}
export function PagedResponseOfUserListEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'entries': !exists(json, 'entries') ? undefined : (json['entries'].map(UserListEntryFromJSON)),
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'hasNext': !exists(json, 'hasNext') ? undefined : json['hasNext'],
        'hasPrevious': !exists(json, 'hasPrevious') ? undefined : json['hasPrevious'],
        'nextPage': !exists(json, 'nextPage') ? undefined : PageRequestFromJSON(json['nextPage']),
        'page': !exists(json, 'page') ? undefined : json['page'],
        'previousPage': !exists(json, 'previousPage') ? undefined : PageRequestFromJSON(json['previousPage']),
        'size': !exists(json, 'size') ? undefined : json['size']
    };
}
export function PagedResponseOfUserListEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'metaData': MetaDataToJSON(value.metaData),
        'totalElements': value.totalElements,
        'entries': value.entries === undefined ? undefined : (value.entries.map(UserListEntryToJSON)),
        'numberOfElements': value.numberOfElements,
        'hasNext': value.hasNext,
        'hasPrevious': value.hasPrevious,
        'nextPage': PageRequestToJSON(value.nextPage),
        'page': value.page,
        'previousPage': PageRequestToJSON(value.previousPage),
        'size': value.size
    };
}
